<p-dialog [visible]="visible"
          (visibleChange)="visibleChange.emit($event)"
          [modal]="true"
          [closable]="!deleting"
          [dismissableMask]="!deleting"
          [style]="{width: '40vw'}"
          header="Eliminar archivo">

    <ng-template pTemplate="content">
        <div class="p-fluid">
            <div class="flex justify-content-center mb-3" *ngIf="archivo">
                <strong class="mb-3 text-xl">{{ archivo.nombre || archivo.hash }}</strong>
            </div>
            <div class="flex justify-content-center">
                <p-floatLabel>
                    <textarea
                        id="id-commentarios"
                        pInputTextarea
                        cols="80"
                        rows="8"
                        [minlength]="20"
                        [maxlength]="250"
                        [required]="true"
                        [autoResize]="true"
                        [(ngModel)]="comentarios"
                        placeholder="Motivo de eliminación...">
                    </textarea>
                    <label class="text-xl mb-2" for="id-commentarios"><strong>Comentarios:</strong></label>
                </p-floatLabel>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" class="p-button-text"
                icon="pi pi-times" (click)="cancel()" [disabled]="deleting"></button>

        <button pButton label="Eliminar" icon="pi pi-trash"
                (click)="confirm()" [disabled]="deleting||comentarios.length<20"></button>
    </ng-template>
</p-dialog>
